export default theme => ({
  loading: {
    margin: "auto"
  }
});
